import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { SectionWrapper } from 'Components/Section/SectionWrapper'
import { SectionTitle } from 'Components/Section/SectionTitle'
import SubmitButton from 'Components/Form/SubmitButton'
import { SubmitButtonBlock } from 'Components/Form/SubmitButton/SubmitButtonBlock'
import { Input } from 'Components/Form/Input'
import Note from 'Components/Note'
import { number, roundNumber, required } from 'Utils/Validators/formValidation'
import Form from 'Components/Form'
import UIBlocker from '../UIBlocker'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  yellow: { color: '#FDB600' },
}))

const SpyDetails = ({
  isSaving,
  isEdit,
  defaultValues,
  updateCitySpySettings,
}) => {
  const classes = useStyles()

  const [values, setValues] = useState(defaultValues)

  const {
    hourlyRate,
    maxBudgetPerWeek,
    travelAllowancePerMission,
    travelAllowanceCap,
    durationHandToHandMission,
    durationLetterboxMission,
    missionsPerShift,
    durationShift,
  } = values

  const editSpySettingsProp = (prop, value) => {
    setValues({
      ...values,
      [prop]: value ? Number(value) : null,
    })
  }

  const onSubmitSpySettings = (form, isValid) => {
    if (isValid) {
      for (const key in values) {
        values[key] = values[key] === null ? null : +values[key]
      }
      updateCitySpySettings(values)
    }
  }

  return (
    <SectionWrapper className="section-wrapper">
      <SectionTitle className="section-title">Spy Details</SectionTitle>
      <Form onSubmit={onSubmitSpySettings}>
        <Row>
          <Col xs={3}>
            <Input
              label="Spy hourly rate in local CURR"
              initValue={hourlyRate}
              onChange={e => editSpySettingsProp('hourlyRate', e.target.value)}
              name="hourlyRate"
              validator={[required, number]}
              cypress_id={'edit-city-spy-hourly-rate-input'}
              disabled={!isEdit}
            />
            <br />
            <Note cypress_id={'edit-city-spy-hourly-rate-note'}>
              in local currency
            </Note>
          </Col>
          <Col xs={3}>
            <Input
              label="Max spy budget per week"
              initValue={maxBudgetPerWeek}
              onChange={e =>
                editSpySettingsProp('maxBudgetPerWeek', e.target.value)
              }
              name="maxBudgetPerWeek"
              cypress_id={'edit-city-max-spy-budget-per-week-input'}
              disabled={!isEdit}
            />
            <br />
            <Note cypress_id={'edit-city-max-spy-budget-per-week-note'}>
              if blank = no limit
              <br />
              if 0 = spies can't book mission
            </Note>
          </Col>
          <Col xs={3}>
            <Input
              label="Travel allowance per spy mission"
              initValue={travelAllowancePerMission}
              onChange={e =>
                editSpySettingsProp('travelAllowancePerMission', e.target.value)
              }
              validator={[required, number]}
              name="travelAllowancePerMission"
              cypress_id={'edit-city-travel-allowance-per-spy-mission-input'}
              disabled={!isEdit}
            />
            <br />
            <Note
              cypress_id={'edit-city-travel-allowance-per-spy-mission-note'}
            >
              mission = 1 pair of BA to spy on
            </Note>
          </Col>
          <Col xs={3}>
            <Input
              label="Travel allowance cap"
              initValue={travelAllowanceCap}
              onChange={e =>
                editSpySettingsProp('travelAllowanceCap', e.target.value)
              }
              name="travelAllowanceCap"
              cypress_id={'edit-city-travel-allowance-cap-input'}
              disabled={!isEdit}
            />
            <br />
            <Note cypress_id={'edit-city-travel-allowance-cap-note'}>
              if blank = no limit
              <br />
              in local currency,
              <br />
              Some cities have weekly unlimited trips card, so CM should cap the
              travel allowance to the value of this card , could be no cap.
            </Note>
          </Col>
        </Row>

        <Row>
          <Col xs={3}>
            <Input
              label="Duration H2H spy mission (mins)"
              initValue={durationHandToHandMission}
              onChange={e =>
                editSpySettingsProp('durationHandToHandMission', e.target.value)
              }
              validator={[required, number, roundNumber]}
              name="durationHandToHandMission"
              cypress_id={'edit-city-duration-h2h-spy-mission-input'}
              disabled={!isEdit}
            />
            <br />
            <Note cypress_id={'edit-city-duration-h2h-spy-mission-note'}>
              in minutes 1 mission = 1 BA
            </Note>
          </Col>
          <Col xs={3}>
            <Input
              label="Duration D2D spy mission (mins)"
              initValue={durationLetterboxMission}
              onChange={e =>
                editSpySettingsProp('durationLetterboxMission', e.target.value)
              }
              validator={[required, number, roundNumber]}
              name="durationLetterboxMission"
              cypress_id={'edit-city-duration-lb-spy-mission-input'}
              disabled={!isEdit}
            />
            <br />
            <Note cypress_id={'edit-city-duration-lb-spy-mission-note'}>
              in minutes 1 mission = 1 BA
            </Note>
          </Col>
          <Col xs={3}>
            <Input
              label="Duration spy shift (hours)"
              initValue={durationShift}
              onChange={e =>
                editSpySettingsProp('durationShift', e.target.value)
              }
              validator={[required, number, roundNumber]}
              name="durationShift"
              cypress_id={'edit-city-spy-shift-duration-input'}
              disabled={!isEdit}
            />
            <br />
            {durationShift > 3 && (
              <Note cypress_id={'edit-city-spy-shift-duration-note'}>
                <span className={classes.yellow}>
                  Spy shift duration over 3 hours is uncommon.
                </span>
              </Note>
            )}
          </Col>
          <Col xs={3}>
            <Input
              label="Missions per spy shift"
              initValue={missionsPerShift}
              onChange={e =>
                editSpySettingsProp('missionsPerShift', e.target.value)
              }
              validator={[required, number, roundNumber]}
              name="missionsPerShift"
              cypress_id={'edit-city-missions-per-spy-shift-input'}
              disabled={!isEdit}
            />
            <br />
            <Note cypress_id={'edit-city-missions-per-spy-shift-note'}>
              {missionsPerShift
                ? `Spy will have to book ${missionsPerShift} locations to complete their shift`
                : null}
            </Note>
          </Col>
        </Row>

        {isEdit && (
          <SubmitButtonBlock float="left">
            <SubmitButton
              value="Save"
              onClick={function(e) {
                e.preventDefault()
              }}
              cypress_id={'edit-city-submit-spy-details-button'}
            />
          </SubmitButtonBlock>
        )}
        {isSaving ? <UIBlocker>Loading...</UIBlocker> : null}
      </Form>
    </SectionWrapper>
  )
}

export default SpyDetails
